<template>
<div>
    <Cbarra>
        <template slot="slotTitle">Comisiones y Comités</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <a href="#">Cuerpos Colegiados</a> / <router-link :to="{name:'comision'}">Comisiones y Comités</router-link>
        </template>
    </Cbarra>

    <div class="container">
        <div class="bg-principal">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 shadow_principal">
                    <div class="nav flex-column nav-pills bolt mt-4 mb-4" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-uno-tab" data-toggle="pill" href="#v-pills-uno"
                            role="tab" aria-controls="v-pills-uno" aria-selected="true">
                            Comisiones
                        </a>
                        <div class="nav-link title-call">
                            Comités <i class="fas fa-angle-down color8 ml-1"></i>
                        </div>
                        <a class="nav-link sub-menu" id="v-pills-dos-tab" data-toggle="pill" href="#v-pills-dos"
                            role="tab" aria-controls="v-pills-dos" aria-selected="false">
                            Comité de ética
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-03-tab" data-toggle="pill" href="#v-pills-03"
                            role="tab" aria-controls="v-pills-03" aria-selected="false">
                            Comité editorial
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-04-tab" data-toggle="pill" href="#v-pills-04"
                            role="tab" aria-controls="v-pills-04" aria-selected="false">
                            Comité educación continua
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-05-tab" data-toggle="pill" href="#v-pills-05"
                            role="tab" aria-controls="v-pills-05" aria-selected="false">
                            Comité de cómputo
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-06-tab" data-toggle="pill" href="#v-pills-06"
                            role="tab" aria-controls="v-pills-06" aria-selected="false">
                            Comité de formación complementaria
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-07-tab" data-toggle="pill" href="#v-pills-07"
                            role="tab" aria-controls="v-pills-07" aria-selected="false">
                            Comité de divulgación de la CyT
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-08-tab" data-toggle="pill" href="#v-pills-08"
                            role="tab" aria-controls="v-pills-08" aria-selected="false">
                            Comité de formación y capacitación docente
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-09-tab" data-toggle="pill" href="#v-pills-09"
                            role="tab" aria-controls="v-pills-09" aria-selected="false">
                            Comité de campus sustentable
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-10-tab" data-toggle="pill" href="#v-pills-10"
                            role="tab" aria-controls="v-pills-10" aria-selected="false">
                            Comité de becas
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-11-tab" data-toggle="pill" href="#v-pills-11"
                            role="tab" aria-controls="v-pills-11" aria-selected="false">
                            Comité de prácticas de campo
                        </a>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
                    <div class="tab-content mt-4 mb-4" id="v-pills-tabContent">

                        <div class="tab-pane fade show active" id="v-pills-uno" role="tabpanel"
                            aria-labelledby="v-pills-uno-tab">
                            
                            <h3 class="color_Azul mt-3 mb-3" >Comisiones</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab1.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-dos" role="tabpanel" aria-labelledby="v-pills-dos-tab">
                            
                            <h3 class="color_Azul mt-3 mb-3" >Comité de ética</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab2.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-03" role="tabpanel" aria-labelledby="v-pills-03-tab ">
                            

                            <h3 class="color_Azul mt-3 mb-3" >Comité editorial</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab3.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-04" role="tabpanel" aria-labelledby="v-pills-04-tab ">
                            
                            <h3 class="color_Azul mt-3 mb-3" >Comité educación continua</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab4.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-05" role="tabpanel" aria-labelledby="v-pills-05-tab ">
                            
                            <h3 class="color_Azul mt-3 mb-3" >Comité de cómputo</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab5.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-06" role="tabpanel" aria-labelledby="v-pills-06-tab ">
                            
                            <h3 class="color_Azul mt-3 mb-3" >Comité de formación complementaria</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab6.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-07" role="tabpanel" aria-labelledby="v-pills-07-tab ">
                            
                            <h3 class="color_Azul mt-3 mb-3" >Comité de divulgación de la CyT</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab7.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-08" role="tabpanel" aria-labelledby="v-pills-08-tab ">
                            
                            <h3 class="color_Azul mt-3 mb-3" >Comité de formación y capacitación docente</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab8.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-09" role="tabpanel" aria-labelledby="v-pills-09-tab">
                            
                            <h3 class="color_Azul mt-3 mb-3" >Comité de campus sustentable</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab9.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-10" role="tabpanel" aria-labelledby="v-pills-10-tab">
                            
                            <h3 class="color_Azul mt-3 mb-3" >Comité de becas</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab10.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-11" role="tabpanel" aria-labelledby="v-pills-11-tab">
                            
                            <h3 class="color_Azul mt-3 mb-3" >Comité de prácticas de campo</h3> 
                            <hr class="divider-02 hr-sm-left-0 bg-color">

                            <div  v-for="(lista,key) in objTab11.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <!--TEXTO --> 
                                                <h5 v-show="(item.TipoTema == 'TEXTO' && item.Titulo !='')" class="color_Azul">{{item.Titulo}}</h5> 
                                                <h6 v-show="(item.TipoTema == 'TEXTO' && item.Subtitulo != '')" class="ml-4 color8 mb-4"><b>{{item.Subtitulo}}</b></h6>
                                                <div class="form-group row list-icon" v-if="(item.TipoTema == 'TEXTO')">
                                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                                                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></div>
                                                    </div>
                                                </div>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
  </div>
</template>

<script>
export default {
    data() {
        return {
            urlApi:"inicio/investigacion",
            ListaContenido:[],
            oferta:{},
            Segurity:{},
            ConfCatalogo:{
				title:'ComisionesComites',
				isModal: true,
				obj: {}
            },
            ConfFiltro:{
				placeHSearch:'Puesto',
				valueSearch:'',
				entrada:25,
				pag:1,
				totalItems:0,
				pageSize:0,
            },
            ConfAcciones:{
            },
            ConfigBtnModal2:{
                emitAdd: 'NuevoModal2',
                emitDel: 'EliminarDetalle'
            },
            configBtnContactos:{
                emitAdd: 'FormContactos',
                emitDel: 'DeleteContactos',
            },
			ConfModal: {
				ShowPie: true,
                Size:'md',
            },
            oBoton1:{
                NameOk:'Crear',
                ShowPie:true,
            },
            oModal2:{
                Titulo: 'Detalles del Tema',
                Size:'lg',
            },
            oBoton2:{
                TipoModal:2,
                ShowPie:true,
            },
            objTema1:{
                editar:false,
                Apartado: 'COMISIONESCOMITES',
                Realiza: 'AddTema'
            },
            objTab1:{
                editar:false,
                Apartado: 'COMISIONESCOMITES',
                ListaDet: [],
            },

            objTema2:{
                editar:false,
                Apartado: 'COMISIONESCOMITEETICA',
                Realiza: 'AddTema'
            },
            objTab2:{
                editar:false,
                Apartado: 'COMISIONESCOMITEETICA',
                ListaDet: [],
            },

            objTema3:{
                editar:false,
                Apartado: 'COMISIONESCOMITEEDITORIAL',
                Realiza: 'AddTema'
            },
            objTab3:{
                editar:false,
                Apartado: 'COMISIONESCOMITEEDITORIAL',
                ListaDet: [],
            },

            objTema4:{
                editar:false,
                Apartado: 'COMISIONESCOMITEEDUCCONTINUA',
                Realiza: 'AddTema'
            },
            objTab4:{
                editar:false,
                Apartado: 'COMISIONESCOMITEEDUCCONTINUA',
                ListaDet: [],
            },

            objTema5:{
                editar:false,
                Apartado: 'COMISIONESCOMITECOMPUTO',
                Realiza: 'AddTema'
            },
            objTab5:{
                editar:false,
                Apartado: 'COMISIONESCOMITECOMPUTO',
                ListaDet: [],
            },

            objTema6:{
                editar:false,
                Apartado: 'COMISIONESCOMITEFORMACION',
                Realiza: 'AddTema'
            },
            objTab6:{
                editar:false,
                Apartado: 'COMISIONESCOMITEFORMACION',
                ListaDet: [],
            },

            objTema7:{
                editar:false,
                Apartado: 'COMISIONESCOMITEDIVULGACIONCyT',
                Realiza: 'AddTema'
            },
            objTab7:{
                editar:false,
                Apartado: 'COMISIONESCOMITEDIVULGACIONCyT',
                ListaDet: [],
            },

            objTema8:{
                editar:false,
                Apartado: 'COMISIONESCOMITECAPDOCENTE',
                Realiza: 'AddTema'
            },
            objTab8:{
                editar:false,
                Apartado: 'COMISIONESCOMITECAPDOCENTE',
                ListaDet: [],
            },

            objTema9:{
                editar:false,
                Apartado: 'COMISIONESCOMITECAMPUSSUSTENTABLE',
                Realiza: 'AddTema'
            },
            objTab9:{
                editar:false,
                Apartado: 'COMISIONESCOMITECAMPUSSUSTENTABLE',
                ListaDet: [],
            },

            objTema10:{
                editar:false,
                Apartado: 'COMISIONESCOMITEBECAS',
                Realiza: 'AddTema'
            },
            objTab10:{
                editar:false,
                Apartado: 'COMISIONESCOMITEBECAS',
                ListaDet: [],
            },

            objTema11:{
                editar:false,
                Apartado: 'COMISIONESCOMITEPRACTICASCAMPO',
                Realiza: 'AddTema'
            },
            objTab11:{
                editar:false,
                Apartado: 'COMISIONESCOMITEPRACTICASCAMPO',
                ListaDet: [],
            },

            RutaFile: '',
            RutaFileD: '',
            listIconos: [],
            contactReturn: 'ComisionesComite',
        }
    },methods: {
        async Lista()
        {
            await this.$http.get(this.urlApi, {
					params:{Seccion:'COMISIONESCOMITES',TxtBusqueda:'',Entrada:'',pag:'',RegEstatus: 'A',Orden:'SI'}
                }
            ).then((res) => {
				this.ConfFiltro.pag			= res.data.pagination.CurrentPage;
				this.ConfFiltro.totalItems 	= res.data.pagination.TotalItems;
				this.ConfFiltro.pageSize	= res.data.pagination.PageSize;
                this.Segurity				= res.data.segurity;
                this.RutaFile               = res.data.RutaFile;
                this.RutaFileD              = res.data.RutaFileD;
                this.listIconos             = res.data.listIconos;
                
                let newObj1 = [];
                let newObj2 = [];
                let newObj3 = [];
                let newObj4 = [];
                let newObj5 = [];
                let newObj6 = [];
                let newObj7 = [];
                let newObj8 = [];
                let newObj9 = [];
                let newObj10 = [];
                let newObj11 = [];

               
                $.each(res.data.tema, function(key, value)
                {
                    if(value.Apartado == 'COMISIONESCOMITES'){
                        newObj1.push(value)
                    }
                    else if(value.Apartado == 'COMISIONESCOMITEETICA'){
                        newObj2.push(value)
                    } 
                    else if(value.Apartado == 'COMISIONESCOMITEEDITORIAL'){
                        newObj3.push(value)
                    }                     
                    else if(value.Apartado == 'COMISIONESCOMITEEDUCCONTINUA'){
                        newObj4.push(value)
                    }  
                    else if(value.Apartado == 'COMISIONESCOMITECOMPUTO'){
                        newObj5.push(value)
                    }  
                    else if(value.Apartado == 'COMISIONESCOMITEFORMACION'){
                        newObj6.push(value)
                    }  
                    else if(value.Apartado == 'COMISIONESCOMITEDIVULGACIONCyT'){
                        newObj7.push(value)
                    }  
                    else if(value.Apartado == 'COMISIONESCOMITECAPDOCENTE'){
                        newObj8.push(value)
                    }  
                    else if(value.Apartado == 'COMISIONESCOMITECAMPUSSUSTENTABLE'){
                        newObj9.push(value)
                    }  
                    else if(value.Apartado == 'COMISIONESCOMITEBECAS'){
                        newObj10.push(value)
                    }  
                    else if(value.Apartado == 'COMISIONESCOMITEPRACTICASCAMPO'){
                        newObj11.push(value)
                    } 
                });
                if(newObj1.length > 0){
                    this.objTab1.editar = true;
                    this.objTab1.ListaDet = newObj1;
                }
                if(newObj2.length > 0){
                    this.objTab2.editar = true;
                    this.objTab2.ListaDet = newObj2;
                }
                if(newObj3.length > 0){
                    this.objTab3.editar = true;
                    this.objTab3.ListaDet = newObj3;
                }
                if(newObj4.length > 0){
                    this.objTab4.editar = true;
                    this.objTab4.ListaDet = newObj4;
                }
                if(newObj5.length > 0){
                    this.objTab5.editar = true;
                    this.objTab5.ListaDet = newObj5;
                }
                if(newObj6.length > 0){
                    this.objTab6.editar = true;
                    this.objTab6.ListaDet = newObj6;
                }
                if(newObj7.length > 0){
                    this.objTab7.editar = true;
                    this.objTab7.ListaDet = newObj7;
                }
                if(newObj8.length > 0){
                    this.objTab8.editar = true;
                    this.objTab8.ListaDet = newObj8;
                }
                if(newObj9.length > 0){
                    this.objTab9.editar = true;
                    this.objTab9.ListaDet = newObj9;
                }
                if(newObj10.length > 0){
                    this.objTab10.editar = true;
                    this.objTab10.ListaDet = newObj10;
                }
                if(newObj11.length > 0){
                    this.objTab11.editar = true;
                    this.objTab11.ListaDet = newObj11;
                }
            });
        },
    },mounted() {
        this.Lista();
    },
}
</script>

<style>

</style>